// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mj27v","title":"styles_title__Pa8Rx","imgWrapper":"styles_imgWrapper__1zAi4","link":"styles_link__jTgk3"};